import { useContext, useEffect } from 'react'
import { ROOT_URL } from 'gatsby-env-variables'
import ROUTES from 'Routes'
import If from '@mobi/components/If'
import SEO from 'components/Seo'
import ResetBaseButton from 'components/ResetBaseButton'
import { useContent } from 'modules/Content'
import { ThemeContext } from 'modules/Theme'
import FeatureToggleWidget from 'components/FeatureToggleWidget'
import featureToggle from 'utils/featureToggle'
import { removeGatsbyFocusWrapperTabIndex } from 'utils/accessibility'
import analyticsUuid from 'utils/analyticsUuid'
import { handleSourceOrigin } from 'utils/isSourceOrigin'
import isClient from 'utils/isClient'
const { resetCpf } = featureToggle()
import './LandingLayout.scss'
import { addVariablesGTM } from 'utils/GA/addVariablesGTM'

const LandingLayout = ({ children }) => {
  const { theme } = useContext(ThemeContext)

  const { favicon } = useContent('config')

  useEffect(() => {
    removeGatsbyFocusWrapperTabIndex()

    analyticsUuid.createAnalyticsUuid()
    handleSourceOrigin()

    addVariablesGTM()
  }, [])

  const handleCpfRouteRedirect = () => {
    if (isClient() && window.location.pathname === '/cpf') {
      return {
        'http-equiv': 'refresh',
        content: `2;url=${ROOT_URL}${ROUTES.register.path}`,
      }
    }
  }

  return (
    <div className="app-layout">
      <SEO
        title="Renegocie Recovery: Quite Dívidas Com Até 98% De Desconto"
        description="Negocie dívidas 100% online, com segurança e até 98% de desconto no acordo. Limpe o nome na Recovery."
        keywords="Negociação de dívidas, limpar o nome, renegociar dívida, aumentar score, feirão limpa nome, recovery"
        faviconHref={theme !== 'recovery' ? favicon?.filename : 'Favicon.ico'}
        metaRobots={
          isClient() && window.location.href.includes('lojasavenida')
            ? 'noindex, nofollow'
            : null
        }
        meta={{
          ...handleCpfRouteRedirect(),
        }}
      />
      <main className="main-content">{children}</main>

      <If condition={resetCpf} renderIf={<ResetBaseButton />} />
      <FeatureToggleWidget />
    </div>
  )
}

export default LandingLayout
